import AddParameterAlertModal from './containers/AddParameterAlertModalContainer'

export default AddParameterAlertModal
